import React, { useEffect, useState } from "react";
import Banner from "../components/Banner/Banner";
import SheetBuilder from "../components/Home/SheetBuilder";
import { Navigate, Link } from "react-router-dom";
import ArtButton from "../components/Home/ArtButton";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Check, CheckBoxRounded, Star, StarRounded } from "@mui/icons-material";

export default function HomePage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [showWhatsNew, setShowWhatsNew] = useState(false);

  useEffect(() => {
    const hasSeen = localStorage.getItem("sodtf-whats-new-v6");
    if (!hasSeen) setShowWhatsNew(true);
  }, []);

  return (
    <div
      className="home-page"
      style={{
        overflowX: "hidden",
        overflowY: "auto",
        maxWidth: "100vw",
      }}
    >
      {showWhatsNew && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.75)",
            zIndex: 2000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontFamily: "Anek Latin",
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              border: "3px solid #94C940",
              padding: "2rem",
              paddingTop: 0,
              borderRadius: "12px",
              color: "#5A6872",
              maxWidth: "50%",
              textAlign: "center",
              boxShadow: "0 0 20px rgba(0,0,0,0.3)",
            }}
          >
            <h2
              style={{
                fontSize: "2rem",
                marginBottom: "1rem",

                color: "#5A6872",
              }}
            >
              What’s New?
            </h2>
            <div
              style={{
                fontSize: "1.2rem",
                marginBottom: "1rem",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "0.5rem",
                }}
              >
                <StarRounded style={{ marginRight: "0.5rem" }} />
                <span>
                  <b>We just rolled out Email Verification!</b>
                </span>
              </div>
              <div style={{ textAlign: "left" }}>
                New accounts now require email confirmation before accessing the
                site. This is the first step in a larger security upgrade.
                Stronger auth options and more safeguards are coming soon to
                keep your account safer than ever.
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "0.75rem",
                marginTop: "0.5rem",
              }}
            >
              <button
                onClick={() => {
                  localStorage.setItem("sodtf-whats-new-v6", "true");
                  setShowWhatsNew(false);
                }}
                style={{
                  backgroundColor: "#5A6872",
                  color: "white",
                  border: "none",
                  padding: "0.75rem 1.5rem",
                  fontSize: "1.2rem",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontFamily: "Anek Latin",
                }}
              >
                Okay
              </button>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                margin: "1rem",
                marginBottom: "-1rem",
                justifyContent: "center",
              }}
            >
              <span>
                Please forward any suggestions & bugs to{" "}
                <span style={{ color: "#94C940" }}>cs@seeourdesigns.com</span>.
              </span>
            </div>
          </div>
        </div>
      )}
      {isMobile ? (
        <div>
          <Banner />
          <div
            className="perks"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-evenly",
              color: "#5A6872",
              fontFamily: "Anek Latin",
            }}
          >
            <div
              style={{
                maxWidth: "500px",
                textAlign: "center",
                marginBottom: "1rem",
              }}
            >
              <h2
                style={{
                  fontSize: "2.5rem",
                  marginBottom: "0.5rem",
                  marginTop: "0.5rem",
                }}
              >
                Easy to Order
              </h2>
              <img
                src="/imagedtf.png"
                alt=""
                style={{
                  width: "150px",
                  height: "auto",
                  marginBottom: "0.5rem",
                }}
              />
              <p
                style={{
                  width: "18rem",
                  margin: "0 auto",
                  color: "black",
                  fontSize: "1.25rem",
                }}
              >
                Our handy sheet{" "}
                <a
                  href="/dtf-sheet-builder"
                  style={{
                    borderBottom: "2px solid #94C940",
                    color: "inherit",
                    textDecoration: "none",
                    display: "inline-block",
                    verticalAlign: "top",
                  }}
                >
                  Design Portal
                </a>{" "}
                allows you to upload images and preview your full transfer order
                <br />
                in one place.
                <br></br>
                <br></br>
                Creating an account archives your previously uploaded artwork,
                making it convenient to reorder.
              </p>
            </div>
            <div
              style={{
                maxWidth: "500px",
                textAlign: "center",
                marginBottom: "1rem",
              }}
            >
              <h2
                style={{
                  fontSize: "2.25rem",
                  marginBottom: "0.5rem",
                  marginTop: "0.5rem",
                }}
              >
                Fair Price, Guaranteed
              </h2>
              <img
                src="/fairprice.png"
                alt=""
                style={{
                  width: "150px",
                  height: "auto",
                  marginBottom: "0.5rem",
                }}
              />
              <p
                style={{
                  width: "19rem",
                  margin: "0 auto",
                  color: "black",
                  fontSize: "1.25rem",
                }}
              >
                Unlike other transfer services, our pricing is determined by the{" "}
                <span style={{ color: "#94C940" }}>size of your design</span>{" "}
                instead of a predetermined canvas, which means a more accurate
                and customer-friendly price.
              </p>
            </div>
            <div style={{ flex: 1, maxWidth: "500px", textAlign: "center" }}>
              <h2
                style={{
                  fontSize: "2.25rem",
                  marginBottom: "0.5rem",
                  marginTop: "0.5rem",
                }}
              >
                Clear Communication
              </h2>
              <img
                src="/emailicon.png"
                alt=""
                style={{
                  width: "150px",
                  height: "auto",
                  marginBottom: "0.5rem",
                }}
              />
              <p
                style={{
                  width: "19rem",
                  margin: "0 auto",
                  color: "black",
                  fontSize: "1.25rem",
                }}
              >
                We send order confirmation and completion emails for your
                convenience and peace of mind.
                <br></br>
                <br></br>Plus, our portal allows you to check the status of your
                order, from us receiving it all the way to it being printed and
                rolled!
              </p>
            </div>
          </div>

          <div className="designAd">
            <p style={{ fontFamily: "Anek Latin", fontSize: "1.25rem" }}>
              Try out our Design Portal below!
            </p>
            <SheetBuilder />
          </div>
          <div
            className="design-help"
            style={{
              backgroundColor: "rgb(91, 103, 110)",
              fontFamily: "Anek Latin",
            }}
          >
            <h1
              style={{ color: "#fff", fontSize: "2.5rem", paddingTop: "2rem" }}
            >
              Need Design Help?
            </h1>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginTop: "-2rem",
              }}
            >
              <p
                style={{
                  color: "#fff",
                  fontSize: "1.4rem",
                  marginBottom: "0.5rem",
                  width: "90%",
                }}
              >
                Want to remove a pesky background or change your art's color? We
                can help!
              </p>
              <p
                style={{
                  color: "#fff",
                  fontSize: "1.4rem",
                  width: "90%",
                  textAlign: "center",
                  margin: 0,
                }}
              >
                From simple tweaks to fully original design concepts, our team
                will assist in making your design dreams a reality!
              </p>
            </div>
            <div style={{ paddingTop: "2rem", paddingBottom: "2rem" }}>
              <ArtButton />
            </div>
          </div>

          <div
            id="getInTouch"
            style={{ backgroundColor: "#94C940", fontFamily: "Anek Latin" }}
          >
            <h1 style={{ color: "#fff", fontSize: "3rem", paddingTop: "2rem" }}>
              Get In Touch
            </h1>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "1.5rem",
                paddingBottom: "2rem",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  maxWidth: "500px",
                  width: "80%",
                }}
              >
                <img
                  src="/location.png"
                  alt=""
                  style={{ width: "2rem", height: "auto", marginRight: "1rem" }}
                />
                <a
                  href="https://www.google.com/maps?q=360+E+Maple+Rd+Suite+M+Troy+MI+48083"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    fontSize: "1.5rem",
                    margin: 0,
                    color: "#fff",
                    fontWeight: "100",
                    textAlign: "left",
                    textDecoration: "none",
                    lineHeight: "1.6",
                  }}
                >
                  360 E Maple Rd Suite M <br />
                  Troy, Mi 48083
                </a>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  maxWidth: "500px",
                  width: "80%",
                }}
              >
                <img
                  src="/email.png"
                  alt=""
                  style={{ width: "2rem", height: "auto", marginRight: "1rem" }}
                />
                <a
                  href="mailto:cs@seeourdesigns.com"
                  style={{
                    fontSize: "1.5rem",
                    margin: 0,
                    color: "#fff",
                    fontWeight: "100",
                    textAlign: "left",
                    textDecoration: "none",
                  }}
                >
                  cs@seeourdesigns.com
                </a>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  maxWidth: "500px",
                  width: "80%",
                }}
              >
                <img
                  src="/phone.png"
                  alt=""
                  style={{ width: "2rem", height: "auto", marginRight: "1rem" }}
                />
                <a
                  href="tel:13138012500"
                  style={{
                    fontSize: "1.5rem",
                    margin: 0,
                    color: "#fff",
                    fontWeight: "100",
                    textAlign: "left",
                    textDecoration: "none",
                  }}
                >
                  (313) 801-2500
                </a>
              </div>
            </div>
            <div
              id="businessHours"
              style={{ marginTop: "2rem", paddingBottom: "2rem" }}
            >
              <h2 style={{ color: "#fff", fontSize: "2rem" }}>
                Business Hours
              </h2>
              <p
                style={{
                  color: "#fff",
                  fontSize: "1.5rem",
                  marginBottom: "0.1rem",
                }}
              >
                Monday-Friday: 9am - 5pm
              </p>
              <p
                style={{
                  color: "#fff",
                  fontSize: "1.5rem",
                  marginTop: "0.1rem",
                }}
              >
                Saturday and Sunday: CLOSED
              </p>
            </div>
          </div>
        </div>
      ) : (
        <>
          <Banner />
          <div
            className="perks"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
              color: "#5A6872",
              fontFamily: "Anek Latin",
            }}
          >
            <div style={{ flex: 1, maxWidth: "500px", textAlign: "center" }}>
              <h2 style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>
                Easy to Order
              </h2>
              <img
                src="/imagedtf.png"
                alt=""
                style={{
                  width: "100px",
                  height: "auto",
                  marginBottom: "0.5rem",
                }}
              />
              <p style={{ width: "17rem", margin: "0 auto", color: "black" }}>
                Our handy sheet{" "}
                <a
                  href="/dtf-sheet-builder"
                  style={{
                    borderBottom: "2px solid #94C940",

                    color: "inherit",
                    textDecoration: "none",
                    display: "inline-block",
                    verticalAlign: "top",
                  }}
                >
                  Design Portal
                </a>{" "}
                allows you to upload images and preview your full transfer order
                in one place.
                <br></br>
                <br></br>
                Creating an account archives your previously uploaded artwork,
                making it convenient to reorder.
              </p>
            </div>
            <div style={{ flex: 1, maxWidth: "500px", textAlign: "center" }}>
              <h2 style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>
                Fair Price, Guaranteed
              </h2>
              <img
                src="/fairprice.png"
                alt=""
                style={{
                  width: "100px",
                  height: "auto",
                  marginBottom: "0.5rem",
                }}
              />
              <p style={{ width: "17rem", margin: "0 auto", color: "black" }}>
                Unlike other transfer services, our pricing is determined by the{" "}
                <span style={{ color: "#94C940" }}>size of your design</span>{" "}
                instead of a predetermined canvas, which means a more accurate
                and customer-friendly price.
              </p>
            </div>
            <div style={{ flex: 1, maxWidth: "500px", textAlign: "center" }}>
              <h2 style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>
                Clear Communication
              </h2>
              <img
                src="/emailicon.png"
                alt=""
                style={{
                  width: "100px",
                  height: "auto",
                  marginBottom: "0.5rem",
                }}
              />
              <p style={{ width: "17rem", margin: "0 auto", color: "black" }}>
                We send order confirmation and completion emails for your
                convenience and peace of mind.
                <br></br>
                <br></br>Plus, our portal allows you to check the status of your
                order, from us receiving it all the way to it being printed and
                rolled!
              </p>
            </div>
          </div>

          <div className="designAd">
            <p style={{ fontFamily: "Anek Latin" }}>
              Try out our Design Portal below!
            </p>
            <SheetBuilder />
          </div>
          <div
            className="design-help"
            style={{
              backgroundColor: "rgb(91, 103, 110)",
              fontFamily: "Anek Latin",
            }}
          >
            <h1 style={{ color: "#fff", fontSize: "3rem", paddingTop: "2rem" }}>
              Need Design Help?
            </h1>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginTop: "-2rem",
              }}
            >
              <p
                style={{
                  color: "#fff",
                  fontSize: "1.75rem",
                  marginBottom: "0.5rem",
                }}
              >
                Want to remove a pesky background or change your art's color? We
                can help!
              </p>
              <p
                style={{
                  color: "#fff",
                  fontSize: "1.75rem",
                  width: "60%",
                  textAlign: "center",
                  margin: 0,
                }}
              >
                From simple tweaks to fully original design concepts, our team
                will assist in making your design dreams a reality!
              </p>
            </div>
            <div style={{ paddingTop: "2rem", paddingBottom: "2rem" }}>
              <ArtButton />
            </div>
          </div>
          <div
            id="getInTouch"
            style={{ backgroundColor: "#94C940", fontFamily: "Anek Latin" }}
          >
            <h1 style={{ color: "#fff", fontSize: "3rem", paddingTop: "2rem" }}>
              Get In Touch
            </h1>
            <div
              id="contactInfo"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-evenly",
                gap: "2rem",
              }}
            >
              <div
                style={{
                  flex: 1,
                  maxWidth: "500px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src="/location.png"
                  alt=""
                  style={{ width: "2rem", height: "auto", marginRight: "1rem" }}
                />
                <a
                  href="https://www.google.com/maps?q=360+E+Maple+Rd+Suite+M+Troy+MI+48083"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    fontSize: "1.5rem",
                    margin: 0,
                    color: "#fff",
                    fontWeight: "100",
                    textAlign: "left",
                    textDecoration: "none",
                    lineHeight: "1.6",
                  }}
                >
                  360 E Maple Rd Suite M <br />
                  Troy, Mi 48083
                </a>
              </div>
              <div
                style={{
                  flex: 1,
                  maxWidth: "500px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src="/email.png"
                  alt=""
                  style={{ width: "2rem", height: "auto", marginRight: "1rem" }}
                />
                <a
                  href="mailto:cs@seeourdesigns.com"
                  style={{
                    fontSize: "1.5rem",
                    margin: 0,
                    color: "#fff",
                    fontWeight: "100",
                    textAlign: "left",
                    textDecoration: "none",
                  }}
                >
                  cs@seeourdesigns.com
                </a>
              </div>
              <div
                style={{
                  flex: 1,
                  maxWidth: "500px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src="/phone.png"
                  alt=""
                  style={{ width: "2rem", height: "auto", marginRight: "1rem" }}
                />
                <a
                  href="tel:13138012500"
                  style={{
                    fontSize: "1.5rem",
                    margin: 0,
                    color: "#fff",
                    fontWeight: "100",
                    textAlign: "left",
                    textDecoration: "none",
                  }}
                >
                  (313) 801-2500
                </a>
              </div>
            </div>
            <div
              id="businessHours"
              style={{ marginTop: "2rem", paddingBottom: "2rem" }}
            >
              <h2 style={{ color: "#fff", fontSize: "1.2rem" }}>
                Business Hours
              </h2>
              <p style={{ color: "#fff", fontSize: "1.2rem" }}>
                Monday-Friday: 9am - 5pm
              </p>
              <p style={{ color: "#fff", fontSize: "1.2rem" }}>
                Saturday and Sunday: CLOSED
              </p>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
